import styled, { keyframes } from "styled-components"
import Overlay from "../../Componentes/Overlay"
import Modal from "../../Componentes/Utils/Modal"
import { useModal } from "../../contexts/ModalContext"
import axios from "axios"
import { useState } from "react"
import { useToast } from "../../contexts/ToastContext"
import { LuLoaderCircle } from "react-icons/lu";


const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`
const Title = styled.h2`
    font-size: 16px;
    color: #333;
    margin: 0 0 10px 0;
`
const Text = styled.p`
    font-size: 14px;
    color: #555;
    margin: 0 0 30px;
`
const ButtonGroup = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`
const Button = styled.button`
    width: 100px;
    height: 32px;
    padding: 8px 16px;
    font-size: 14px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s;
    background-color: ${(props) => (props.variant === 'confirm' ? '#dc2626' : '#ccc')};
    color: ${(props) => (props.variant === 'confirm' ? '#fff' : '#000')};
    &:hover {
        background-color: ${(props) => (props.variant === 'confirm' ? '#b91c1c' : '#999')};
    }
    display: flex;
    align-items: center;
    justify-content: center;
`
const LoadingIcon = styled(LuLoaderCircle)`
    color: #fff;
    animation: ${ spin } 1s linear infinite;
    margin: 0 auto;
    font-size: 23px;
`

const ModalQuartoDelete = ({ quarto, fetchQuartos, fetchReps }) => {

    const { closeModal } = useModal();
    const { notifySuccess, notifyError } = useToast();

    const [ loading, setLoading ] = useState( false );

    const handleDelete = async () => {

        setLoading( true );

        try{
            const { data } = await axios.post(`https://sistemaintegrado.palmont.com.br/Painel/API/Republicas/DeleteQuarto/index.php?id=${ quarto.identifier }`, {
                withCredentials: true
            });

            console.log( data );

            await fetchQuartos();
            await fetchReps();

            notifySuccess("Quarto excluído com sucesso.");

            closeModal();

        }catch(e){
            
            notifyError("Ocorreu um erro ao tentar excluir o quarto.");
            console.error( e );

        }finally{
            setLoading( false );
        }

    }

    return(
        <>
            <Overlay state={ true } >
                <Modal size="md" >
                    <Title>Tem certeza que deseja excluir o quarto "{quarto.quarto_name}" ?</Title>
                    <Text>Essa ação não poderá ser desfeita.</Text>
                    <ButtonGroup>
                        <Button disabled={ loading } variant="cancel" onClick={closeModal} >Cancelar</Button>
                        <Button disabled={ loading } variant="confirm" onClick={handleDelete} >{ loading ? <LoadingIcon /> : "Confirmar" }</Button>
                    </ButtonGroup>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalQuartoDelete;